import * as actionTypes from '../actions/actionTypes';
import * as ArticleTypes from 'Flow2/components/Article/ArticleTypes/ArticleTypes';
import { updateObject } from '../utility';

const INITIAL_STATE = {
    articleObjects: {
        articleLogs: {},
        articleReports: {},
        articleAllReports: {},
        articleTimeComments: {},
        articleViewFields: {},
        articleElements: {},
        articleMount: {},
        articlePublished: { showOverlay: false },
        articleEditor: {},
        articleMedia: {},
        articlePagination: { totalPages: 1, currentPage: 1, limit: ArticleTypes.LIMIT },
    },
    articles: null,
    activeArticle: null,
    currentArticle: 0,
    loading: false,
    searchArticles: null,
}

const articleReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.UPDATE_ARTICLE_OBJECTS:
            return { ...state, articleObjects: { ...state.articleObjects, ...action.payload } }
        case actionTypes.ARTICLES_GET_START:
            return updateObject(state, { loading: true });
        case actionTypes.ARTICLES_GET_SUCCESS:
            console.log(action);
            return updateObject(state, { loading: false, articles: action.articles });
        case actionTypes.ARTICLES_SEARCH_SUCCESS:
            return updateObject(state, { loading: false, searchArticles: action.searchArticles });
        case actionTypes.ARTICLES_SEARCH_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_GET_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_SET_CURRENT:
            return updateObject(state, { currentArticle: action.id });
        case actionTypes.GET_ARTICLE_BY_DIST_SUCCESS:
            return updateObject(state, { loading: false, articles: action.articles });
        case actionTypes.ARTICLES_SEARCH_REPORT_START:
            return updateObject(state, { loading: true });
        case actionTypes.ARTICLES_SEARCH_REPORT_SUCCESS:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_SEARCH_REPORT_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_EDIT_REPORT_START:
            return updateObject(state, { loading: true });
        case actionTypes.ARTICLES_EDIT_REPORT_SUCCESS:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_EDIT_REPORT_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_PUBLISH_ARTICLE_START:
            return updateObject(state, { loading: true });
        case actionTypes.ARTICLES_PUBLISH_ARTICLE_SUCCESS:
            return updateObject(state, { loading: false });
        case actionTypes.ARTICLES_PUBLISH_ARTICLE_FAIL:
            return updateObject(state, { loading: false });
        default:
            return state;
    }
}

export default articleReducer;
